const AthleteManager = () => import("./AthleteManager.vue");

export default {
  path: "/organization_profile/athletes",
  name: "clubadmin.athlete.manager",
  component: AthleteManager,
};
